"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.listRole = exports.deleteAccessRole = exports.updateAccessRole = exports.createAccessRole = exports.getAccessRoleByID = exports.getAccessRole = exports.ROLE_BASE_URL = void 0;
const core_1 = require("@schoolbase/core");
const axios_1 = __importDefault(require("axios"));
const index_1 = require("./index");
exports.ROLE_BASE_URL = (index_1.SRV_ENV || process.env.NODE_ENV === 'production') ?
    index_1.RoleBaseUrl : "http://localhost:3001";
const roleUrl = `${exports.ROLE_BASE_URL}${core_1.API_ROLE}`;
async function getAccessRole(token) {
    const response = await axios_1.default.get(roleUrl, {
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
        }
    });
    if (response.status <= 299) {
        return response.data;
    }
    else if (response.status == 401) {
        throw new core_1.UnauthorizedError(response.data.message);
    }
    else {
        throw new core_1.HttpError(response.data.message, response.status);
    }
}
exports.getAccessRole = getAccessRole;
async function getAccessRoleByID(id, token) {
    const response = await axios_1.default.get(roleUrl + id, {
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
        }
    });
    if (response.status <= 299) {
        return response.data;
    }
    else if (response.status == 401) {
        throw new core_1.UnauthorizedError(response.data.message);
    }
    else {
        throw new core_1.HttpError(response.data.message, response.status);
    }
}
exports.getAccessRoleByID = getAccessRoleByID;
async function createAccessRole(role) {
    const response = await axios_1.default.post(roleUrl, role);
    if (response.status <= 299) {
        return response.data;
    }
    else if (response.status == 401) {
        throw new core_1.UnauthorizedError(response.data.message);
    }
    else {
        throw new core_1.HttpError(response.data.message, response.status);
    }
}
exports.createAccessRole = createAccessRole;
async function updateAccessRole(id, role) {
    const response = await axios_1.default.put(roleUrl + id, role);
    if (response.status <= 299) {
        return response.data;
    }
    else if (response.status == 401) {
        throw new core_1.UnauthorizedError(response.data.message);
    }
    else {
        throw new core_1.HttpError(response.data.message, response.status);
    }
}
exports.updateAccessRole = updateAccessRole;
async function deleteAccessRole(id) {
    const roleUrl = `${exports.ROLE_BASE_URL}${core_1.API_ROLE}`;
    const response = await axios_1.default.delete(roleUrl + id);
    if (response.status <= 299) {
        return response.data;
    }
    else if (response.status == 401) {
        throw new core_1.UnauthorizedError(response.data.message);
    }
    else {
        throw new core_1.HttpError(response.data.message, response.status);
    }
}
exports.deleteAccessRole = deleteAccessRole;
exports.listRole = [
    {
        value: "super_admin",
        name_en: "Super Admin",
        name_kh: "រដ្ឋបាលជាន់ខ្ពស់"
    },
    {
        value: "top_manager",
        name_en: "Top Manager",
        name_kh: "អ្នកគ្រប់គ្រងកំពូល"
    },
    {
        value: "major_admin_cs",
        name_en: "School Coordinator Computer Science",
        name_kh: "អ្នកគ្រប់គ្រងសាលាវិទ្យាសាស្រ្តកំព្យូទ័រ"
    },
    {
        value: "major_admin_ecom",
        name_en: "School Coordinator Ecommerce",
        name_kh: "អ្នកគ្រប់គ្រងសាលាពាណិជ្ជកម្មអេឡិចត្រូនិច"
    },
    {
        value: "major_admin_tn",
        name_en: "School Coordinator Telecommunication",
        name_kh: "អ្នកគ្រប់គ្រងសាលាទូរគមនាគមន៍"
    },
    {
        value: "major_admin_foundation",
        name_en: "School Coordinator Foundation",
        name_kh: "អ្នកគ្រប់គ្រងថ្នាក់មូលដ្ឋាន"
    },
    {
        value: "tsc",
        name_en: "Teaching Support Center",
        name_kh: "ការិយាល័យគាំទ្រការសិក្សា"
    }
];
